import { render, staticRenderFns } from "./Quotations&Invoices.vue?vue&type=template&id=6c84aa86&"
import script from "./Quotations&Invoices.vue?vue&type=script&lang=js&"
export * from "./Quotations&Invoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports